import React from 'react';
import {connect} from "react-redux";
import {bidCalendarSelector, bidStatusSelector, bidViewSelector} from './selectors'
import {NavLink} from "react-router-dom";
import URI from 'urijs';
import * as R from 'ramda';
import moment from "moment";
import PropTypes from 'prop-types';
import Sticky from 'react-sticky-fill'
import {Button, Card, Col, DatePicker, Divider, Input, message, Popover, Row, Select} from "antd";
import {createBid, deleteBid, getBid, getBids, getBidsIndex, leaveBid, userWillBid} from "../../actions/bids";
import {getBidCalendarReport, getBidStatusReport} from "../../actions/reports";
import {buildSummaryChartData} from "../../projections";
import CompanySmall from "../Boilerplate/CompanySmall";
import DateDisplay from "../Boilerplate/DateDisplay";
import DateTimeDisplay from "../Boilerplate/DateTimeDisplay";
import ExpandedList from "../Boilerplate/ExpandedList";
import SearchBox from "../Boilerplate/SearchBox";
import UserSmall from '../Boilerplate/UserSmall';
import {CodeTag} from "../Boilerplate/CodeTag";
import {Schedule} from "../Boilerplate/Schedule";
import {canDelete} from "../Boilerplate/permissions";
import {separatorJoin} from "../Boilerplate/utilities";
import AddressLink from "../AddressLink";
import SummaryChart from "../Projects/SummaryChart";
import {setViewPath} from "../../actions/view";
import {CountdownTimer} from "../Boilerplate/CountdownTimer";
import {DeleteButton} from "./DeleteButton";
import {UnfollowButton} from "./UnfollowButton";

const filterState = {
  sortBy: 'datecreated',
  sortOrder: 'descending',
  dateRange: [null, null],
  statusFilter: null,
  limit: 20,
  filterKeys: null,
};

const initialState = {
  ...filterState,
  calendarDate: moment(),
  calendarMode: 'month',
  loading: true,
};

const mapFiltersStateToUrl = (filters) => {
  let status;
  const { sortBy: sortby, sortOrder: order, size: limit, statusFilter, filterKeys: search } = { ...filters };
  if (statusFilter) {
    status = statusFilter;
  }
  return { ...filters, sortby, order, limit, status, search };
};

const BidHeading = () => <Row className='bid-listing-heading text-column' gutter={18}>
  <Col xs={8} sm={9} md={10} lg={7}>Bid Name</Col>
  <Col xs={4} sm={3} lg={2}>Bid #</Col>
  <Col xs={6} lg={5}>Entered By</Col>
  <Col xs={0} lg={3}>Pre-Bid Mtg Date</Col>
  <Col xs={0} lg={3}>Bid Due Date</Col>
  <Col xs={0} sm={6} md={5} lg={4}>Status</Col>
  <Col xs={6} sm={0} className='status-column-right'>Status</Col>
</Row>;

const BidItemHead = ({ bid, onFilter, onDelete, onLeave, handleWontBid }) => {
  let options = [];
  options.push(canDelete(bid) ?
    <DeleteButton fauxKey={'delete-' + bid.resource.id} type='delete' title='Delete Bid'
                  bid={bid} onDelete={onDelete}/> :
    <UnfollowButton fauxKey={'leave-' + bid.resource.id} type='close-circle' title='Unfollow Bid'
                    bid={bid} onLeave={onLeave} handleWontBid={handleWontBid}/>);
  return <Row className='bid-listing-content' type='flex' justify='space-between' gutter={18}>
    <Col xs={8} sm={9} md={10} lg={7} className='text-column collapse-ellipses'>
      <NavLink to={"/bids/" + bid.resource.id}>{bid.resource.name}</NavLink>
    </Col>
    <Col xs={4} sm={3} lg={2} className='text-column'><span>{bid.resource.number}</span></Col>
    <Col xs={6} lg={5} className='text-column'>
      <CompanySmall id={bid.resource.ownercompanyid}/>
    </Col>
    <Col xs={0} lg={3}>
      <DateDisplay date={bid.resource.prebidmeetingdatetime}/>
    </Col>
    <Col xs={0} lg={3}>
      <DateDisplay date={bid.resource.bidduedatetime}/>
    </Col>
    <Col xs={0} sm={3} md={2}>
      <div className='status-column'>
        <CodeTag
          code={bid.resource.status}
          table='bidstatus'
          onClick={() => onFilter(bid.resource.status)}
        />
      </div>
    </Col>
    <Col xs={0} sm={3} lg={2}>
      <div className='actions-column status-column status-column-right'>
        <div>
          {separatorJoin(options, <br/>)}
        </div>
      </div>
    </Col>
    <Col xs={6} sm={0}>
      <div className='actions-column status-column status-column-right'>
        <div>
          <CodeTag
            code={bid.resource.status}
            table='bidstatus'
            onClick={() => onFilter(bid.resource.status)}
          />
        </div>
        <div>
          {separatorJoin(options, <br/>)}
        </div>
      </div>
    </Col>
  </Row>;
};

BidItemHead.propTypes = {
  bid: PropTypes.any,
  onDelete: PropTypes.func,
  onLeave: PropTypes.func,
  onFilter: PropTypes.func,
  handleWontBid: PropTypes.func,
};

const BidDetails = ({ bid }) => <Row>
  <Col span={12}>
    <Row>
      <strong className='details-heading'>Bid Due Date</strong>
      <DateTimeDisplay className='details-data' date={bid.resource.bidduedatetime}/>
      <strong className='details-heading'>Pre-Bid Meeting Date</strong>
      {bid.resource.prebidmeeting ?
          <DateTimeDisplay
              className={"details-data" + (!bid.resource.prebidmeetingrequired ? "" : " color-secondary-1-0")}
              date={bid.resource.prebidmeetingdatetime}/> : null}
    </Row>
    <Row>
      <strong className='details-heading'>Created On</strong>
      <DateDisplay className='formatted-text details-data' date={bid.resource.datecreated}/>
      <strong className='details-heading'>Entered By</strong>
      <UserSmall className='formatted-text details-data' id={bid.resource.createdbyuserid}/>
      <strong className='details-heading'>Bid Lead</strong>
      <UserSmall className='details-data' id={bid.resource.owneruserid}/>
    </Row>
  </Col>
  <Col span={12}>
    {bid.resource.bidduedatetime && <Row>
      <strong className='details-heading'>Bid Time Remaining</strong>
      <CountdownTimer timestamp={bid.resource.bidduedatetime}/>
    </Row>}
    <Row>
      <strong className='details-heading'>Site Address</strong>
      <AddressLink address={bid.resource.address ? {
        street: bid.resource.address,
        suite: bid.resource.address2,
        city: bid.resource.city,
        state: bid.resource.state,
        zip: bid.resource.zip
      } : null}/>
    </Row>
    <Row>
      <strong className='details-heading'>Architect</strong>
      <p className='formatted-text details-data'>{bid.resource.architectname}</p>
      <strong className='details-heading'>Engineer</strong>
      <p className='formatted-text details-data'>{bid.resource.engineername}</p>
      <strong className='details-heading'>Site Owner</strong>
      <p className='formatted-text details-data'>{bid.resource.siteownername}</p>
    </Row>
  </Col>
</Row>;

BidDetails.propTypes = { bid: PropTypes.any };

const BidItemBody = ({ bid }) => <div className='bid-listing-full-content'>
  <div className='bid-listing-watermark'>
    <img src={`/static/media/logos/${bid.resource.createdbycompanyid}`} alt=''/>
  </div>
  <Col className='bid-listing-full-content-text'>
    <Row gutter={32}>
      <Col span={24}>
        <NavLink to={"/bids/" + bid.resource.id}><h1 className='list-title'>{bid.resource.name}</h1></NavLink>
        <hr/>
      </Col>
      <Col xs={0} sm={14} className='details-info'>
        <BidDetails bid={bid}/>
      </Col>
      <Col className='details-description'>
        <p className='formatted-text'><strong className='details-heading'>Description</strong></p>
        <p className='formatted-text text-wrap'>{bid.resource.description}</p>
      </Col>
      <Col xs={24} sm={0}>
        <BidDetails bid={bid}/>
      </Col>
    </Row>
  </Col>
</div>;

BidItemBody.propTypes = { bid: PropTypes.any };

class BidList extends React.Component {
  constructor(props) {
    super(props);
    const filters = this.mapFiltersUrlToState(new URI().query(true));
    this.state = { ...initialState, ...filters };
    this.searchInputRef = null;
  }

  componentDidMount() {
    const { onMount } = this.props;
    if (onMount) {
      onMount();
    }
  }

  componentDidUpdate(prevProps) {
    const { bidsindex: index } = this.props;
    const { bidsindex: prevIndex } = prevProps;
    if (index !== prevIndex) {
      this.setState({ loading: false })
    }
  }

  mapFiltersUrlToState = (filters) => {
    const { sortby: sortBy, order: sortOrder, from, to, status, limit: size, search: filterKeys } = { ...filters };
    let result = {};
    if (sortBy) result.sortBy = sortBy;
    if (sortOrder) result.sortOrder = sortOrder;
    if (from || to) result.dateRange = [moment(from), moment(to)];
    if (status) result.statusFilter = status;
    if (size) result.size = size;
    if (filterKeys) result = { ...result, filterKeys };
    return result;
  };

  updateFilters = (filters, remount = true, reload = true) => {
    this.setState({ loading: reload });

    filters = this.checkFilters(filters);

    this.props.history.push({ search: URI().search(filters).search() });

    const { onMount } = this.props;
    remount && onMount && onMount();
  };

  setFilter = (phrase) => {
    this.setState({ filterKeys: phrase });

    this.updateFilters({ filterKeys: phrase });
    this.searchInputRef.setValue(phrase);
  };

  setSortBy = (sortBy) => {
    this.setState({ sortBy });

    this.updateFilters({ sortBy });
  };

  setSortOrder = (sortOrder) => {
    this.setState({ sortOrder });

    this.updateFilters({ sortOrder });
  };

  clearSort = () => {
    const { sortBy, sortOrder } = filterState;
    this.setState({ sortBy, sortOrder });
    this.updateFilters({ sortBy, sortOrder });
  };

  setDateRange = (range) => {
    this.setState({ calendarDate: range[0] });

    this.updateFilters({ dateRange: range });
  };

  checkFilters = (overrides, includeSearch = true) => {
    const urlFilters = this.mapFiltersUrlToState(new URI().query(true));
    let { sortby, order, dateRange, status, statusFilter, limit, search } = mapFiltersStateToUrl({ ...this.state, ...urlFilters, ...overrides });
    const [from, to] = dateRange;

    let newFilters = {};
    if (sortby !== filterState.sortBy) newFilters.sortby = sortby;
    if (order !== filterState.sortOrder) newFilters.order = order;
    if (dateRange !== filterState.dateRange) {
      if (from) newFilters.from = moment(from).startOf('day').format();
      if (to) newFilters.to = moment(to).endOf('day').format();
    }
    if (statusFilter !== filterState.statusFilter && status) newFilters.status = status;
    if (limit && limit !== filterState.limit) newFilters.limit = limit;
    if (includeSearch && search && search !== filterState.filterKeys) newFilters.search = search;

    return newFilters;
  };

  clearDateRange = () => this.setDateRange(filterState['dateRange']);

  setFilterCode = (code) => {
    this.setState({
      statusFilter: code
    });

    this.updateFilters({ statusFilter: code });
  };

  clearFilterCode = () => {
    this.setFilterCode(null);
  };

  handleGraphClick = (e) => {
    let category = e.name;
    let { statusSummary } = this.props;
    let chosen = statusSummary.find(x => x.key.name === category);
    if (chosen) {
      this.setFilterCode(chosen.key.code);
    }
  };

  handleCalendarChange = (day, mode, update = true) => {
    let dateRange;

    this.setState({
      calendarMode: mode,
      calendarDate: day
    });

    if (!update) return;

    if (mode === 'year') {
      dateRange = [moment(day).startOf('month'), moment(day).endOf('month')];
    } else {
      dateRange = [day, day];
    }

    this.setState({ dateRange: dateRange });
    this.updateFilters({ dateRange }, dateRange !== this.state.dateRange, dateRange !== this.state.dateRange);
  };

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  handlePageChange = (page, size) => {
    const { onPageChange, bidsindex } = this.props;
    this.setState({ page, size });
    if (size !== this.state.size) this.updateFilters({ size }, false, false);
    onPageChange && onPageChange(page, size, bidsindex);
  };

  clearFilters = () => {
    this.setState(filterState);
    this.updateFilters(filterState);
  };

  render() {
    let { bidsindex, bids, statusSummary, datesSummary, onNew } = this.props;
    const {
      sortBy,
      sortOrder,
      dateRange,
      calendarDate,
      statusFilter
    } = this.state;

    bids = bids || [];

    const { sortby, order, from, to, search } = this.checkFilters();
    const hasRange = from || to;
    const isSorted = sortby || order;

    const appliedFilters = !!isSorted + !!hasRange + !!statusFilter + !!search;

    let chartData = buildSummaryChartData(statusSummary);
    const InputGroup = Input.Group;
    const Option = Select.Option;

    const isEmpty = obj => { for (let x in obj) { return false; } return true; };

    const renderFilterControls = () => <div className='bid-listing-control'>
      {statusFilter &&
      <CodeTag
        className='control-clear'
        closable
        onClose={this.clearFilterCode}
        code={statusFilter}
        table='bidstatus'
      />
      }
      <InputGroup compact className='control-box'>
        <div className='ant-input-group-addon ant-input-group-compact-addon control-filter'><span>Sort By</span>
        </div>
        <Select onChange={(value) => this.setSortBy(value)} value={sortBy} defaultValue={sortBy || 'datecreated'}
                dropdownStyle={{ zIndex: 1033 }}>
          <Option value='datecreated'>Date Created</Option>
          <Option value='bidduedatetime'>Bid Due Date</Option>
          <Option value='prebidmeetingdatetime'>Pre-Bid Meeting Date</Option>
        </Select>
        <Select onChange={(value) => this.setSortOrder(value)} value={sortOrder}
                defaultValue={sortOrder || 'descending'} dropdownStyle={{ zIndex: 1033 }}>
          <Option value='ascending'>Ascending</Option>
          <Option value='descending'>Descending</Option>
        </Select>
      </InputGroup>
      <DatePicker.RangePicker
        className='control-box'
        value={dateRange}
        onChange={(range) => this.setDateRange(range)}
        format='MM/DD/YYYY'
      />
    </div>;

    return (
      <Row className='bid-listing' type="flex" justify="center" gutter={16}>
        <Col xl={0} md={12} xs={24} className='overview-top'>
          <Card id='top-status'>
            <div className='top-status-container'>
              <div className='top-status-container-inner-translate'>
                <SummaryChart
                  data={chartData}
                  title='Bids by Status'
                  onClick={this.handleGraphClick}
                />
              </div>
            </div>
          </Card>
        </Col>
        <Col xl={0} md={12} xs={24} className='overview-top'>
          <Card>
            <Schedule value={calendarDate} onChange={this.handleCalendarChange} callouts={datesSummary}/>
          </Card>
        </Col>
        <Col xl={18} xs={24}>
          <Card>
            <div className='bid-listing-header'>
              <h1>Bids</h1>
              <SearchBox
                className='control-box control-search'
                placeholder='Search bids...'
                onChange={this.setFilter}
                defaultValue={this.state.filterKeys}
                ref={el => this.searchInputRef = el}
              />
            </div>
            <div>
              <Divider/>
              <ExpandedList
                index={bidsindex}
                serverSidePagination
                onPageChange={this.handlePageChange}
                items={bids}
                loading={this.state.loading}
                extra={(<React.Fragment>
                  <Popover placement='bottom' content={renderFilterControls()} trigger='click'>
                    <Button icon='filter' className={(!isEmpty(this.checkFilters(null, false))) && 'background-primary-1 color-grayscale-3'}>
                      <span className='hidden inline visible-lg'>Filter</span>
                    </Button>
                  </Popover>
                  <Button className='background-secondary-2-3 border-secondary-2-3'
                          disabled={!this.props.bidcreator}
                          type='primary' icon='plus' onClick={onNew}>
                    <span className='hidden inline visible-lg'>New Bid</span>
                  </Button>
                </React.Fragment>)}
                subExtra={<div>
                  {isSorted && <Button className={'clear-filter'} size="small" onClick={this.clearSort}>Clear Sort</Button>}
                  {search && <Button className={'clear-filter'} size="small" onClick={() => this.setFilter()}>Clear Search</Button>}
                  {hasRange && <Button className={'clear-filter'} size="small" onClick={this.clearDateRange}>Clear Calendar Filter</Button>}
                  {statusFilter && <Button className={'clear-filter'} size="small" onClick={this.clearFilterCode}>Clear Status Filter</Button>}
                  <Button className={'clear-filter'} size="small" style={{ visibility: appliedFilters <= 1 && 'hidden' }} onClick={this.clearFilters}>Clear All Filters</Button>
                </div>}
                derivedKey={item => item.resource.id}
                renderHeading={() => <BidHeading/>}
                renderTop={bid =>
                  <BidItemHead bid={bid}
                               onFilter={this.setFilterCode}
                               onDelete={this.props.onDelete}
                               onLeave={this.props.onLeave}
                  />}
                renderContent={bid => <BidItemBody bid={bid}/>}
                emptyText={isEmpty(this.checkFilters(null, true)) && 'There are no bids within the last eighteen months available to you.'}
              />
            </div>
          </Card>
        </Col>
        <Col xl={6} xs={0}>
          <Sticky className='overview-right'>
            <Card>
              <SummaryChart
                data={chartData}
                title='Bids by Status'
                onClick={this.handleGraphClick}
              />
            </Card>
            <Card>
              <Schedule value={calendarDate} onChange={this.handleCalendarChange} callouts={datesSummary}/>
            </Card>
          </Sticky>
        </Col>
      </Row>
    )
  }
}

BidList.propTypes = {
  bids: PropTypes.arrayOf(PropTypes.object).isRequired,
  bidsindex: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default connect(
  (state, props) => {
    return {
      bidcreator: R.view(R.lensPath(['ui', 'authData', 'createBids']), state),
      bids: bidViewSelector(state),
      bidsindex: state.view.indexes,
      statusSummary: bidStatusSelector(state),
      datesSummary: bidCalendarSelector(state),
    };
  },
  (dispatch, props) => ({
    onMount: () => {
      const filters = new URI().query(true);
      const { limit = 20, sortby, order } = { ...mapFiltersStateToUrl(filterState), ...filters };
      // Default date filter: last 18 months
      const [from, to, filterby] = [moment().subtract(18, 'months').format(), null, ((filters.from || filters.to) && sortby) || 'datecreated'];
      dispatch(setViewPath(['bids']));
      dispatch(getBidsIndex({ filterby, from, to, ...filters, sortby, order }));
      dispatch(getBids({ filterby, from, to, ...filters, limit, sortby, order }));
      dispatch(getBidStatusReport({ filterby, from, to, ...filters, sortby }));
      dispatch(getBidCalendarReport({ filterby, ...filters, sortby, from, to }))
    },
    onPageChange: (page, size, index) => index.slice((page - 1) * size, page * size).forEach(e => dispatch(getBid(e))),
    onAdd: (bid) => dispatch(createBid(bid)),
    onDelete: (bidId) => dispatch(deleteBid(bidId)),
    onLeave: (bidId) => dispatch(leaveBid(bidId)),
    onNew: () => props.history.push('/bids/new'),
    handleWontBid: bid => {
      dispatch(userWillBid(bid.resource.id, false, false));
      message.info(`You have been marked as 'Not Bidding' on ${bid.resource.name}.`);
    },
  })
)(BidList);



// WEBPACK FOOTER //
// ./src/components/Bids/BidList.js